import { render, staticRenderFns } from "./Pupils.vue?vue&type=template&id=65937062&scoped=true&"
import script from "./Pupils.vue?vue&type=script&lang=ts&"
export * from "./Pupils.vue?vue&type=script&lang=ts&"
import style0 from "./Pupils.vue?vue&type=style&index=0&id=65937062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65937062",
  null
  
)

export default component.exports